import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toZonedTime } from 'date-fns-tz';

import Loading from "./components/Loading";
import Header from "./components/Header";

import {
    api, getEventById, getEventInfosByEventId, getTicketTypesByEventId, getTicketTypeInfosByTicketTypeId,
    getTicketTypeNumberOfAvailableTickets
} from "ticketino-api-client";

import "../css/style.css";


const Step20_Tickets = () => {
    const [eventGroup, setEventGroup] = useState({});
    const [event, setEvent] = useState([]);

    const [ticketTypes, setTicketTypes] = useState([]);
    const [selectedTicketTypes] = useState([]);
    const [unlockedTicketTypes, setUnlockedTicketTypes] = useState([]);
    const [isTicketTypesUnlocked, setIsTicketTypesUnlocked] = useState(false);

    const [orderId] = useState(sessionStorage.getItem("OrderId"));
    const [orderTotal, setOrderTotal] = useState(0);

    const [promotioncode, setPromotioncode] = useState("");
    const [promotioncodeAdded, setPromotioncodeAdded] = useState("");
    const [promotionError, setPromotionError] = useState("");
     
    const [disabled, setDisabled] = useState(true);
    const [errors, setErrors] = useState("");
    const [loading, setLoading] = useState(true);

    const [token] = useState(sessionStorage.getItem("token"));

    const timeZone = 'Europe/Zurich';
    const today = new Date();
    const zurichDate = toZonedTime(today, timeZone);  // Convert to Zurich time

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    const { language } = useParams();
    const { eventGroupId } = useParams();
    const { eventId } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        sessionStorage.setItem("EventGroupId", eventGroupId);

        if (orderId) {
            deleteOrderTickets();
            loadEvent(eventId, orderId);
        }
    }, [orderId]); //gets called when an order is started

    const deleteOrderTickets = async () => {
        var response = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);

        var tickets = response.data.tickets;

        if (tickets.length > 0) {
            let ticketsInOrder = [];
            tickets.map(ticket => ticketsInOrder.push(ticket.id));

            let body = { "TicketsToRemove": ticketsInOrder }
            axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, { headers: { Accept: "application/json" }, data: body });
        }

        return response.data;
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadEvent = async (eventId, orderId) => {
        try {
            setLoading(true);

            // Event
            const event = await getEventById(eventId);
            const infos = await getEventInfosByEventId(eventId);

            sessionStorage.setItem("Event1Info", JSON.stringify(infos.eventInfos));

            // sorting it according to the language
            const eventInfo = infos.eventInfos.find(info => info.languageId == languageId);

            // setting the eventInfo object in the info attribute of event
            const updatedEventInfo = { ...event, info: eventInfo };

            let mergedTicketTypes = [];
            const ticketTypes = await getTicketTypesByEventId(eventId);
            const ticketTypesTagged = ticketTypes.map(tt => ({ ...tt, eventId: eventId }));

            mergedTicketTypes = [...ticketTypesTagged];

            sessionStorage.setItem("TicketTypesEvent", JSON.stringify(mergedTicketTypes));

            const updatedTicketTypes = await Promise.all(
                mergedTicketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);
                    const ticketTypeInfo =
                        info.find(info => info.languageId === languageId) ||
                        info.find(info => info.languageId === 0);
                    const ticketTypeAvailability = await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    return {
                        ...ticketType,
                        info: ticketTypeInfo,
                        availability: ticketTypeAvailability
                    };
                })
            );

            // form settings
            const formsettings = await axios.get(`form/formsettings`);

            // EventGroup
            const eventGroup = await axios.get(`${baseUrl}/EventGroup/${eventGroupId}`);

            // setting final values
            setEvent(updatedEventInfo);
            setTicketTypes(updatedTicketTypes);
            setEventGroup(eventGroup.data);
            setLoading(false);

        } catch (error) {
            console.error(error);
        }
    }

    const addPromotionToOrder = async () => {
        setPromotionError("");
        setLoading(true);

        const updatedUnlockedTicketTypes = await applyPromotionCodeToOrder(orderId, promotioncode);
        let updatedTicketTypes = [];

        updatedTicketTypes = await Promise.all(ticketTypes.map(async (ticketType) => {
            if (updatedUnlockedTicketTypes?.unlockedTicketTypes?.includes(ticketType.id)) {
                const unlockedTicketTypeAvailability = await getTicketTypeAvailability(ticketType.id, orderId, promotioncode);
                ticketType.availability = unlockedTicketTypeAvailability;
            }
            return ticketType;
        }))

        sessionStorage.setItem("addedPromotion", promotioncode);
        setPromotioncodeAdded(promotioncode);

        setTicketTypes(updatedTicketTypes)
        setUnlockedTicketTypes(updatedUnlockedTicketTypes?.unlockedTicketTypes ?? []);
        setIsTicketTypesUnlocked(true);
        setLoading(false);
    }

    const getTicketTypeAvailability = async (ticketTypeId, orderId, promotionCode) => {
        try {
            const response = await axios.get(`${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}&promotionCode=${promotionCode}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources.detailPage?.errorMessage);
        }
    }

    const applyPromotionCodeToOrder = async (orderId, code) => {
        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources.detailPage?.errorMessage);
        }
    }

    const addTicketToBasket = async () => {
        let addTicketTypes = [];

        addTicketTypes = selectedTicketTypes.filter((stt) => stt.quantity !== "0");

        addTicketTypes.map((tt) => {
            if (unlockedTicketTypes.includes(tt.ticketTypeId)) {
                tt.promotionCode = promotioncodeAdded;
            }
        });

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                navigate(`/${language}/shipping`);
            })
            .catch((error) => {
                if (error.response.data == "Ticket type must be bought with another ticket type.") {
                    setErrors(resources?.TicketsErrorMessage);
                } else {
                    setErrors(error.response.data);
                }
            });
    };

    const onSubmit = async () => {
        await addTicketToBasket();
    };

    const onTicketTypeChange = (e, ticketTypeId) => {
        const obj = {
            ticketTypeId: ticketTypeId,
            quantity: e.target.value,
        };

        const existingTicketType = selectedTicketTypes.find(
            (t) => t.ticketTypeId === ticketTypeId
        );

        if (existingTicketType) {
            existingTicketType.quantity = e.target.value;
        } else {
            selectedTicketTypes.push(obj);
        }

        // calcualate quantity and validate
        let quantity = 0;

        selectedTicketTypes.map(s => {
            quantity += s.quantity * 1;
        });

        if (quantity > 0) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

        let totalQuantity = 0;
        let totalPrice = 0;

        selectedTicketTypes.forEach((stt) => {
            totalQuantity = totalQuantity + stt.quantity * 1;

            totalPrice = totalPrice + ticketTypes.find((tt) => tt.id === stt.ticketTypeId).price *
                stt.quantity;
        });

        setOrderTotal(totalPrice);
    };

    const mapTicketTypes = () => {
        let ticketTypesSorted = [];

        if (ticketTypes && ticketTypes.length > 0) {
            ticketTypesSorted = [...ticketTypes].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        // Filter out ticket types with "early" in the name (case-insensitive) and those with availability 0
        const filteredTicketTypes = ticketTypesSorted.filter(tt =>
            !(tt.info?.name?.toLowerCase().includes("early")) &&
            tt.availability?.availableTickets > 0 // Only show if availableTickets > 0
        );

        return (
            filteredTicketTypes &&
            filteredTicketTypes.length > 0 &&
            filteredTicketTypes.map((tt, index) => (
                <div key={index}>
                    {((tt.availability?.status === 0 && tt.info?.name.includes("Kinder_deactivated")) ||
                        (new Date(tt.preSaleStart) > zurichDate))
                        ? null : (
                            <div className="row mt-4 mb-3">
                                <div className="col-md-7">
                                    <span className="text-uppercase f-size-20px">
                                        {tt.info?.name}
                                    </span>
                                    <div>
                                        <small>
                                            {tt.info?.description}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-md-3 text-md-end">
                                    <span className="f-size-20px">
                                        {tt.currency} {tt.price.toFixed(2)}
                                    </span>
                                </div>
                                <div className="col-md-2">
                                    <select
                                        className="form-select"
                                        onChange={(e) => onTicketTypeChange(e, tt.id)}>
                                        {Array.from(
                                            Array(
                                                tt.availability?.availableTickets + 1
                                            ),
                                            (e, i) => (
                                                <option key={i} value={i}>
                                                    {i}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                        )}
                </div>
            ))
        );
    };

    return (
        <>
            <Header />

            <div className="container">
                {loading
                    ? (
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="transparent"
                            position="fixed"
                            top="50%"
                            left="50%" />
                    ) : (
                        <>
                            <div className="row">
                                <div className="offset-md-3 col-md-6">
                                    <div className="row">
                                        <div className="col-md-12 f-size-20px text-center">
                                            <p>{resources?.ChooseYourTicketTypes}</p>
                                        </div>
                                    </div>
                                    <div className="mt-5">
                                        <div>
                                            {mapTicketTypes()}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <hr />
                                        </div>
                                    </div>

                                    <div className="row mt-4 mb-3">
                                        <div className="col-md-7">
                                            <span className="text-uppercase f-size-20px">
                                                SUMME
                                            </span>
                                        </div>
                                        <div className="col-md-3 text-md-end">
                                            <span className="f-size-20px">
                                                CHF {orderTotal.toFixed(2)}
                                            </span>
                                        </div>
                                    </div>

                                    {/* promocodes */}
                                    {/*<div className="mt-5">*/}
                                    {/*    <p className="text-subtitle mb-2">{resources.ticketsAddPromocode}</p>*/}
                                    {/*    <div className="row">*/}
                                    {/*        <div className="col-md-4 col-12 mb-3">*/}
                                    {/*            <input className="form-control custom-textbox" value={promotioncode} onChange={(e) => setPromotioncode(e.target.value)} />*/}
                                    {/*            {promotionError !== "" &&*/}
                                    {/*                <span className="error">{promotionError}</span>*/}
                                    {/*            }*/}
                                    {/*        </div>*/}
                                    {/*        <div className="col-md-4">*/}
                                    {/*            <button className="btn custom-button white text-uppercase" disabled={promotioncode < 3} onClick={addPromotionToOrder}>{resources?._Add}</button>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                    {/* buttons */}
                                    <div className="row mt-5 mb-4">
                                        <div className="col-6 text-start">
                                            <button className="btn custom-button white" onClick={() => navigate(-1)}>
                                                {resources && resources._Back}
                                            </button>
                                        </div>
                                        <div className="col-6 text-end">
                                            <button className="btn custom-button" disabled={disabled} onClick={() => onSubmit()}>
                                                WEITER
                                            </button>
                                        </div>
                                    </div>
                                    {errors !== "" && (
                                        <div className="row text-end">
                                            <div className="offset-md-6 col-md-6"></div>
                                            <p className="text-danger ps-2">{errors}</p>
                                        </div>
                                    )}
                                </div>
                                <p className="mt-5 text-center">
                                    {resources &&
                                        (
                                            <small style={{ color: 'grey' }}>powered by <a style={{ color: 'grey' }} href={resources?._TicketinoOrganizerUrl
                                            } target="_blank">TICKETINO</a></small>
                                        )}
                                </p>
                            </div>
                        </>
                    )}
            </div>
        </>
    );
};

export default Step20_Tickets